import { Alert, Drawer } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Womanwithlaptop from "../../Assets/Icons/GroupLaptop.png";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import AuthService from "../../Service.js/authService";
import Input from "../../Components/CommonCommponents/Input";
import toast from "react-hot-toast";

const ConfirmPassword = () => {
    const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [errMsg, setErrMsg] = useState("");
  const { code, token } = useParams();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    // navigate("/");
  };

  const handleClick = () => {
    onClose();
  };

  console.log(token, "token");
  const {
    register,
    control,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    data.code = code;
    data.token = token;
    await AuthService.ResetPassword(data)
      .then(
        (oResponse) => {
          console.log(oResponse, "oResponse");
          if(oResponse?.status === 200){
              toast.success("Password Reset Successfully");
              navigate("/?isLogin=true")
          }
        },
        (error) => {
          console.log(error, "error");
          const errorsObj = error?.response?.data.error_info?.errors?.password;
          console.log(errorsObj, "errorsObj");
          if (errorsObj?.length) {
            setErrMsg(errorsObj[0]);
          }else if(error?.response?.data.error_info?.errors){
            setErrMsg(error?.response?.data.error_info?.errors)
          }
        }
      )
      .catch((error) => {
        toast.error("Failed To Reset");
      });
  };
  console.log(errMsg, "errMsg");
  return (
    <>
      <Drawer
        title={null}
        width={660}
        placement="right"
        open={true}
        style={{
          borderRadius: "50px 0 0 50px",
          // Other styles
        }}
        closeIcon={<div className="custom-close-icon"></div>}
        className="login"
      >
        <div className="mx-20 mt-4">
          <p className="text-3xl font-semibold">Reset Password</p>
        </div>
        <div className="mx-20 mt-4">
          {errMsg && (
            <Alert
              message="Whoops !"
              type="error"
              description={errMsg}
              style={{ width: "100%", margin: "auto" }}
            />
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-10">
              <div className="w-full ">
                <Input
                  type="password"
                  name="password"
                  label=""
                  placeholder="New Password"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  className="h-12"
                />
              </div>
              <div className="w-full ">
                <Input
                  type="password"
                  name="confirm_password"
                  label=""
                  placeholder="Confirm Password"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  className="h-12"
                />
              </div>
            </div>
            <div className="mt-10">
              <button
                className="bg-[#FF4544] text-white w-full rounded-md h-[42px]"
                type="submit"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
        <div className="h-1 bg-[#EAEAEA] mb-14 mx-20"></div>
        <div>
          <div className="flex items-center justify-center">
            <p className="text-xl">Don't have an account?</p>
            <Link
              to="/signup/"
              className="text-xl text-red-500"
              onClick={handleClick}
            >
              Sign Up
            </Link>
          </div>
          <div className="w-full">
            <img src={Womanwithlaptop} alt="gdweh" className="" />
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default ConfirmPassword;
